import React from 'react'
import ReactDOM from 'react-dom/client';

import Index from '../../components/locations/list'
import FlashMessages from "../../components/flash";

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('locations-index')
  if(node) {
    const root = ReactDOM.createRoot(node);
    root.render(
      <div>
        <Index/>
        <FlashMessages />
      </div>
    );
  }
});
